import { jsx as _jsx } from "react/jsx-runtime";
import { useAskInputModeToggleGroupProps } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputModeToggleGroupProps.js';
import { ModeToggleGroup } from '#pplx/frontend/composer-sdk-plugins/mode-toggle/ModeToggleGroup.js';
export function AskInputModeToggleGroup(props) {
    const slotProps = useAskInputModeToggleGroupProps(props);
    return _jsx(ModeToggleGroup, { ...slotProps });
}
//# sourceMappingURL=AskInputModeToggleGroup.js.map